// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scroll-fix-navigation {\n    position: fixed;\n    top: var(--ps-offset-height);\n}\n.scroll-navigation {\n    position: relative;\n}\n.scroll-list-item:hover {\n    background: var(--v-secondary-lighten3);\n}\n.scroll-list-item:hover .list-item-text {\n    color: white;\n}\n.scroll-list-item-active {\n    background: var(--v-secondary-lighten3);\n    color: var(--v-secondary-darken4);\n}\n", ""]);
// Exports
module.exports = exports;
